module.exports = __webpack_public_path__ + "static/media/Logo.d327bc9e.svg";